module.exports = __webpack_public_path__ + "assets/icon-conversation.c3044130.svg";